// common.js

// 전역에 productVariants가 선언되어 있다고 가정합니다.
// 예: product.liquid에서 <script> var productVariants = {{ product.variants | json }}; </script>

function updateVariant() {
  var selectedOptions = [];
  // 모든 옵션의 hidden 필드를 선택하여 값 수집
  document.querySelectorAll('input[id^="option-"][id$="-hidden"]').forEach(function(input) {
    selectedOptions.push(input.value.trim());
  });

  var matchingVariant = null;
  // productVariants 배열에서 selectedOptions와 일치하는 variant 찾기
  for (var i = 0; i < productVariants.length; i++) {
    var variant = productVariants[i];
    var match = true;
    for (var j = 0; j < variant.options.length; j++) {
      if (variant.options[j] !== selectedOptions[j]) {
        match = false;
        break;
      }
    }
    if (match) {
      matchingVariant = variant;
      break;
    }
  }
  
  if (matchingVariant) {
    document.getElementById('selected-variant-id').value = matchingVariant.id;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const buttonGroups = document.querySelectorAll('.button-group');
  
  // 초기 설정
  buttonGroups.forEach(function(group) {
    const optionIndex = group.getAttribute('data-option-index');
    const hiddenField = document.getElementById('option-' + optionIndex + '-hidden');
    
    if (optionIndex === "1") {
      // 컬러 그룹: active가 없으면 첫 번째 버튼에 active를 추가
      if (!group.querySelector('button.option-button.active')) {
        const firstButton = group.querySelector('button.option-button');
        if (firstButton) {
          firstButton.classList.add('active');
          if (hiddenField) hiddenField.value = firstButton.getAttribute('data-value');
        }
      }
    } else {
      // 사이즈 등 다른 그룹: active를 초기화하여 기본 선택 없이 시작
      group.querySelectorAll('button.option-button').forEach(function(btn) {
        btn.classList.remove('active');
      });
      if (hiddenField) hiddenField.value = "";
    }
  });
  
  // 클릭 이벤트 처리
  buttonGroups.forEach(function(group) {
    group.addEventListener('click', function(e) {
      const button = e.target.closest('button.option-button');
      if (!button) return;
      
      const optionIndex = group.getAttribute('data-option-index');
      const hiddenField = document.getElementById('option-' + optionIndex + '-hidden');
      
      if (optionIndex === "1") {
        // 컬러 옵션: 토글 동작 적용
        if (button.classList.contains('active')) {
          // active 상태이면 active 제거
          button.classList.remove('active');
          if (hiddenField) hiddenField.value = "";
        } else {
          // 같은 그룹 내 다른 버튼의 active 제거 후 현재 버튼에 active 추가
          group.querySelectorAll('button.option-button').forEach(function(btn) {
            btn.classList.remove('active');
          });
          button.classList.add('active');
          if (hiddenField) hiddenField.value = button.getAttribute('data-value');
        }
      } else {
        // 사이즈 등 다른 옵션은 항상 하나만 active
        group.querySelectorAll('button.option-button').forEach(function(btn) {
          btn.classList.remove('active');
        });
        button.classList.add('active');
        if (hiddenField) hiddenField.value = button.getAttribute('data-value');
      }
      updateVariant();
    });
  });
});
